export const CorporateCultureMaterialSourceTypeMap = {
    HUMAN_RESOURCE: '1',
    NEWS_RESOURCE: '2',
    PPT_RESOURCE: '3'
}

export const LeaderTypeList = [
    {
        value: '1',
        label: '极度关注客户'
    },
    {
        value: '2',
        label: '偏好行动'
    },
    {
        value: '3',
        label: '力求正确'
    },
    {
        value: '4',
        label: '学习并好奇'
    },
    {
        value: '5',
        label: '节俭'
    },
    {
        value: '6',
        label: '赢得信任'
    },
    {
        value: '7',
        label: '苦练基本功'
    },
    {
        value: '8',
        label: '招聘并发展最佳人才'
    },
    {
        value: '9',
        label: '发表不同意见，承诺执行决定'
    },
    {
        value: '10',
        label: '敢想'
    },
    {
        value: '11',
        label: '深潜'
    },
    {
        value: '12',
        label: '交付结果'
    },
    {
        value: '13',
        label: '发明并简化'
    },
    {
        value: '14',
        label: '主人翁精神'
    },
    {
        value: '15',
        label: '坚持最高标准'
    }
]

export const humanResourceDirectoryList = [
    {
        value: '1',
        label: '领导力原则表情包',
        children: [...LeaderTypeList]
    },
    {
        value: '2',
        label: '领导力原则知识类卡片',
        children: [...LeaderTypeList]
    },
    {
        value: '3',
        label: '领导力原则职场分类素材',
        children: [...LeaderTypeList]
    },
    {
        value: '4',
        label: '领导力原则壁纸/会议室素材',
        children: [...LeaderTypeList]
    },
    {
        value: '5',
        label: '领导力原则漫画系列',
        children: [...LeaderTypeList]
    },
    {
        value: '6',
        label: '公司文化/美团老话',
    },
    {
        value: '7',
        label: '美团头条壁纸',
    },
    {
        value: '8',
        label: '美团头条节气海报',
    },
    {
        value: '9',
        label: '领导力原则礼品周边',
    },
    {
        value: '10',
        label: '其他素材',
    },
]

export const newsBusinessTypeList = [
    {
        value: '1',
        label: '美图外卖'
    },
    {
        value: '2',
        label: '美图优选'
    },
    {
        value: '3',
        label: '美图闪购'
    },
    {
        value: '4',
        label: '美图买药'
    },
    {
        value: '5',
        label: '美图买菜'
    },
    {
        value: '6',
        label: '美图酒店'
    },
    {
        value: '7',
        label: '美图民宿'
    },
    {
        value: '8',
        label: '美图打车'
    },
    {
        value: '9',
        label: '美团骑行'
    },
    {
        value: '10',
        label: '美团电单车'
    },
    {
        value: '11',
        label: '美团配送'
    },
    {
        value: '12',
        label: '美团门票'
    },
    {
        value: '13',
        label: '快驴进货'
    },
    {
        value: '14',
        label: '歪马送酒'
    },
    {
        value: '15',
        label: '美团电商'
    },
    {
        value: '16',
        label: '美团充电宝'
    },
    {
        value: '17',
        label: '自动配送车'
    },
    {
        value: '18',
        label: '无人机'
    },
    {
        value: '19',
        label: '到店餐饮'
    },
    {
        value: '20',
        label: '到店综合'
    },
    {
        value: '21',
        label: '美团企业版'
    },
    {
        value: '22',
        label: '商家服务'
    },
    {
        value: '23',
        label: '新餐饮研究院'
    },
    {
        value: '24',
        label: '美团公益'
    }
]

export const HumanType = [
    {
        value: '-1',
        label: '全部'
    },
    {
        value: '1',
        label: '人力资源'
    },
    {
        value: '2',
        label: '新闻照片/视频'
    },
    {
        value: '3',
        label: 'PPT模板'
    }
]